import { render, staticRenderFns } from "./Instellingen.vue?vue&type=template&id=61132926&scoped=true"
import script from "./Instellingen.vue?vue&type=script&lang=js"
export * from "./Instellingen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61132926",
  null
  
)

export default component.exports